import React, { useMemo } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import FormGroup from '@mui/material/FormGroup';
import { ModulesCtn, ModulesTitle } from './styles';
import CheckboxField from './checkbox-field';

const ProjectModules = props => {
  const { currentProject, formModules = [] } = props;
  const { control } = useFormContext();
  const projects = useSelector(s => s.account.directProjects);

  const isRootProject = useMemo(
    () => Boolean(projects.find(p =>
      p.level === 0 && (p.id === currentProject?.id))),
    [currentProject?.id, projects]
  );

  return (
    <ModulesCtn>
      <ModulesTitle variant="h6">Modules</ModulesTitle>
      <FormGroup row>
        {formModules?.map((m, index) => (
          <Controller
            key={m.id}
            name={`modules.${index}.checked`}
            control={control}
            render={({ field }) => (
              <CheckboxField
                input={field}
                label={m.label}
                checked={Boolean(field.value)}
                disabledCheckbox={m.disabled || isRootProject}
                disabled={isRootProject}
              />
            )}
          />
        ))}
      </FormGroup>
    </ModulesCtn>
  );
};

export default ProjectModules;
